import { makeStyles } from '@material-ui/styles'
import { colors } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  fieldGroup: {
    padding: theme.spacing(2),
  },
  labelInput: {
    fontSize: '16px',
  },
  card: {
    background: theme.palette.backGroundItem.card,
  },
  cardContent: {
    paddingTop: theme.spacing(2),
  },
  actions: {
    marginTop: theme.spacing(3),
  },
  deleteButton: {
    marginLeft: 10,
    background: `linear-gradient(45deg, ${colors.red[900]} 30%, ${colors.red[800]} 90%)`,
    color: 'white',
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    minWidth: '100px',
  },
  subtitle: {
    fontSize: theme.typography.caption.fontSize,
    color: theme.palette.primary.warning,
  },

  divArquivos: {
    padding: theme.spacing(1),
  },
  divTitulo: {
    borderBottom: 'thin solid #DDD',
  },
  grupoEspelho: {
    padding: theme.spacing(2),
  },
  dadoEspelho: {
    fontSize: '13px',
  },
}))

export default useStyles
